import { AutogenModelTableInfo, AutogenRowTableInfo } from "./autogen/AutogenModelTableInfo";

export class ModelTableInfo extends AutogenModelTableInfo<RowTableInfo> {
	constructor() {
		super(RowTableInfo);
	}
}

export class RowTableInfo extends AutogenRowTableInfo {
}